import cn from 'classnames';
import { RadioProps } from './types';

const Radio = (props: RadioProps) => {
  const { isChecked, positionClass } = props;

  return (
    <span
      className={cn(
        'absolute inline-block h-[6px] w-[6px] -translate-y-1/2 rounded-full ring-gray-700 ring-offset-white xs:h-2 xs:w-2',
        positionClass,
        {
          'border border-gray-700 bg-gray-700 ring-[1px] ring-offset-[2px] ':
            isChecked,
        },
        {
          'border-none bg-white ring-[1px] ring-offset-[1.5px]': !isChecked,
        },
      )}
    ></span>
  );
};

export default Radio;
